module.exports = __webpack_public_path__ + "img/uz-46-logo.bc4b65f8.png";